import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import ProfileComplete from "./pages/ProfileComplete";
import Dashboard from "./pages/Dashboard";
import Calculator from "./pages/Calculator";
import CalculatorV2 from "./pages/CalculatorV2";
import Learn from "./pages/Learn";
import Settings from "./pages/Settings";
import AdminLearn from "./pages/AdminLearn";
import AdminUsers from "./pages/AdminUsers";
import AdminFiles from "./pages/AdminFiles";
import AdminFeedback from "./pages/AdminFeedback";
import AdminLearning from "./pages/admin/AdminLearning";
import AdminCompanies from "./pages/admin/AdminCompanies";
import AdminEmissions from "./pages/admin/AdminEmissions";
import AdminReferenceTablesEditor from "./pages/admin/AdminReferenceTablesEditor";
import CBAM from "./pages/CBAM";
import Reports from "./pages/Reports";
import Benchmark from "./pages/Benchmark";
import Guide from "./pages/Guide";
import LearningPathNew from "./pages/LearningPathNew";
import Login from "./pages/Login";
import AcceptInvitation from "./pages/AcceptInvitation";
import SystemStatus from "./pages/SystemStatus";
import CalculatorDemo from "./pages/CalculatorDemo";

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/login"} component={Login} />
      <Route path={"/accept-invitation"} component={AcceptInvitation} />
      <Route path={"/profile/complete"} component={ProfileComplete} />
      <Route path={"/dashboard"} component={Dashboard} />
      <Route path={"/calculator"} component={CalculatorV2} />
      <Route path={"/calculator-old"} component={Calculator} />
      <Route path={"/calculator-demo"} component={CalculatorDemo} />
      <Route path={"/learn"} component={Learn} />
      <Route path={"/learn/:pathId"} component={LearningPathNew} />
      <Route path={"/settings"} component={Settings} />
      <Route path={"/system-status"} component={SystemStatus} />
      <Route path={"/reports"} component={Reports} />
      <Route path={"/benchmark"} component={Benchmark} />
      <Route path={"/guide"} component={Guide} />
      <Route path={"/admin/learn"} component={AdminLearn} />
      <Route path={"/admin/learning"} component={AdminLearning} />
      <Route path={"/admin/users"} component={AdminUsers} />
      <Route path={"/admin/companies"} component={AdminCompanies} />
      <Route path={"/admin/files"} component={AdminFiles} />
      <Route path={"/admin/feedback"} component={AdminFeedback} />
      <Route path={"admin/emissions"} component={AdminEmissions} />
      <Route path={"admin/reference-tables"} component={AdminReferenceTablesEditor} />
      <Route path={"cbam"} component={CBAM} />
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
